module.exports = __webpack_public_path__ + "static/media/conversation.a7152f9a.svg";